const ecolesReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ECOLES':
      return action.data
    default:
      return state
  }
}

export default ecolesReducer
